import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminPanelService } from '../../services/admin-panel.service';
import { APIUrl } from '../../app-service-routing';

export interface UserData {
  firstName: string;
  emailID: string;
  mobileNumber: string;
  gender: string;
  // dob: string,
  received: string,
  sent: string
}

@Component({
  selector: 'app-consumer',
  templateUrl: './consumer.component.html',
  styleUrls: ['./consumer.component.scss']
})


export class ConsumerComponent implements OnInit {
  consumerlist: any;
  alphabet: any;
  displayedColumns: string[] = ['firstName', 'emailID', 'mobileNumber', 'gender', 'received', 'sent'];
  dataSource: MatTableDataSource<UserData>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private router: Router, private service: AdminPanelService, private activeRoute: ActivatedRoute, ) {
  }


  ngOnInit() {
    this.alphabet = 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split('');
    let leter = ''
    this.consumerlists(leter);

  }

  consumerlists(leter) {
    this.service.getReseultSetList(APIUrl.consumerslistUrl + leter).subscribe(response => {
      this.consumerlist = response;
      this.dataSource = new MatTableDataSource(this.consumerlist);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      // console.log(this.consumerlist);
      // this.infoTableDataSource = this.consumerlist;
    }, error => {
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  alphasearch(letter) {
    this.consumerlists(letter);
  }

  getColor(color) {
    switch (color) {
      case 'Deposit':
        return 'green';
      case 'Redeem':
        return 'red';
      case 'HK':
        return 'red';
    }
  }
}
